(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chase-site-manual"] && !Shopify.designMode) return;
  try {
    
const roots = document.querySelectorAll('[data-site-manual]');

roots.forEach((root) => {
  if (root.dataset.manualReady === 'true') return;
  root.dataset.manualReady = 'true';

  const search = root.querySelector('[data-manual-search]');
  const clear = root.querySelector('[data-manual-clear]');
  const filters = [...root.querySelectorAll('[data-manual-filter]')];
  const list = root.querySelector('[data-manual-list]');
  const items = [...root.querySelectorAll('[data-manual-entry]')];
  const empty = root.querySelector('[data-manual-empty]');
  const count = root.querySelector('[data-manual-count]');

  if (!search || !list || !items.length) return;

  items
    .sort((a, b) => Number(a.dataset.sort || 9999) - Number(b.dataset.sort || 9999))
    .forEach((item) => list.appendChild(item));

  let activeCategory = 'all';

  const applyFilters = () => {
    const term = search.value.trim().toLowerCase();
    let visibleCount = 0;
    let onlyMatch = null;

    items.forEach((item) => {
      const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
      const searchMatch = !term || (item.dataset.search || '').includes(term);
      const visible = categoryMatch && searchMatch;

      item.hidden = !visible;

      if (visible) {
        visibleCount += 1;
        onlyMatch = item;
      }
    });

    if (empty) empty.hidden = visibleCount !== 0;
    if (clear) clear.hidden = term.length === 0;
    if (count) count.textContent = visibleCount + ' ' + (visibleCount === 1 ? 'entry' : 'entries');

    if (term && visibleCount === 1 && onlyMatch) {
      const details = onlyMatch.querySelector('details');
      if (details) details.open = true;
    }
  };

  search.addEventListener('input', applyFilters);

  if (clear) {
    clear.addEventListener('click', () => {
      search.value = '';
      search.focus();
      applyFilters();
    });
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      activeCategory = button.dataset.manualFilter || 'all';

      filters.forEach((filter) => {
        const active = filter === button;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      applyFilters();
    });
  });

  applyFilters();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
